// 箭头配置
export const MOBILE_ARROW_OFFSET = "24px";
export const ARROW_OFFSET_CALC = 85;

// 轮播配置
export const MIN_ARTICLES_FOR_CAROUSEL = 3;
export const SLIDER_SPEED = 500;
export const AUTOPLAY_SPEED = 5000;
